import { Signal } from '@angular/core';
export const directionStyles = {
    strokeColor: '#192129',
    strokeOpacity: 1,
    strokeWeight: 2,
};
import { InjectionToken } from '@angular/core';
export interface IIqMcMapLaneStateService {
    setDirections(
        origin: Signal<string>,
        destination: Signal<string>,
        equipmentType: Signal<string>,
        rateType: Signal<string>,
        map: Signal<google.maps.Map>,
    ): Signal<Promise<google.maps.Map>>;
}

export const MC_MAP_LANE_GOOGLE_API_KEY = new InjectionToken<string>(
    'The Google Map API Key for the MC Map Lane',
    {
        providedIn: 'root',
        factory: () => '',
    },
);
